import { addServiceToBasketSilently }
  from '../components/react/PopupStyleAttach/helpers/addServiceToBasketSilently.js';
import { addCareplanToBasketSilently }
  from '../components/react/PopupStyleAttach/helpers/addCareplanToBasketSilently.js';

const UISettings = require('../utils/UISettings.js');

export const initAddToBasketSilently = () => {
  const storeUrl = UISettings.get('global.store_api_url');
  window.addServiceToBasketSilently =
    (productId, serviceId, callback = (_) => _) => addServiceToBasketSilently(storeUrl, productId, serviceId, callback);
  window.addCareplanToBasketSilently =
    (productId, carePlanId, callback = (_) => _) => addCareplanToBasketSilently(storeUrl, productId, carePlanId, callback);
};
